import _ from 'lodash';
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import SimpleReactValidator from 'simple-react-validator';
import {QUOTING, QUOTED, ERROR} from 'pu-data/QuoteSteps';

import defaultState from './defaultState'
import {columnSelected, rowSelected} from "./parameters";

import {doReQuote} from '../api/quote'

export const validator = new SimpleReactValidator();

export const doQuote = createAsyncThunk(
  'surfaceMountCarriers/doQuote',
  async ({name, value}, thunkAPI) => {

    const currentState = thunkAPI.getState();
    const {parameters} = currentState.smc;
    const authToken = document.getElementsByName('authenticity_token')[0].value;
    const variantId = document.getElementById('variant_id').value;

    return doReQuote(parameters, authToken, variantId, parameters.product_quote_number)
  }, {
    condition: ({name, value}, {getState}) => {
      const alterPrice = [
        'carrier_thickness',
        'carrier_length',
        'carrier_width',
        'hold_down_board_quantity',
        'pallet_need_stiffener_bar',
      ]
      if (!alterPrice.includes(name)) {
        return false;
      }
    },
  }
)

const Slice = createSlice({
  name: 'surfaceMountCarriers',
  initialState: defaultState,
  reducers: {
    changeParameter(state, action) {
      const {name, value} = action.payload
      state.parameters[name] = value
      state.parameters.row_selected = rowSelected(state.parameters)
      state.parameters.column_selected = columnSelected(state.parameters)
    },
    addToCart(state, action) {
      if (validator.allValid()) {
        jQuery('#quote_form').submit();
      } else {
        validator.showMessages();
        state.validated = 0 // force update
      }
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(doQuote.pending, (state, action) => {
        state.quoteStep = QUOTING;
      })
      .addCase(doQuote.fulfilled, (state, action) => {
        const quote = action.payload
        state.quoteStep = QUOTED;

        state.quote.line_items = quote.line_items
        state.quote.number = quote.number
        state.quote.variant_id = quote.variant_id
        state.quote.product_name = quote.product_name

        state.parameters.product_quote_number = quote.number
      })
      .addCase(doQuote.rejected, (state, action) => {
        state.quoteStep = ERROR;
      })
  },
})

export const {
  changeParameter,
  addToCart,
} = Slice.actions

export default Slice.reducer
